module.exports = __webpack_public_path__ + "img/left1Icon2.b7187b9a.png";